
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import AdjustmentForm from './adjustmentForm';
import { createAdjustmentApi, getUserByPhoneApi } from '../../utils/apisConsts';

class CreateAdjustment extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Create Adjustment',
                content: <AdjustmentForm isException={false} mostRecent={true} apiName={createAdjustmentApi}/>,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default CreateAdjustment
